<template>

    <div>

        <div class="modifier-group-outer-wrapper" v-for=" ( modifierGroup, modifierGroupKey ) in relevantModifierGroups " :key=" modifierGroupKey " >

            <div :class=" 'modifier-group-title ' + ( modifierGroup.isValid ? 'background-valid' : 'background-invalid' )">

                <p>{{ modifierGroup.QuickModifierGroup.name }}</p>
                <p>{{ modifierGroup.numSelected }}/{{ ( modifierGroup.QuickModifierGroup.maxSelect > 0 ? modifierGroup.QuickModifierGroup.maxSelect : modifierGroup.QuickModifierGroup.minSelect > 0 ? modifierGroup.QuickModifierGroup.minSelect : '-' ) }}</p>
            </div>

            <!-- refactor this into a computed property lol, see Jupiter ModifierGroupComp.vue for reference -->
            <p :class=" 'limit-alert ' + ( modifierGroup.isValid ? 'alert-blue' : 'alert-red' )" v-if=" modifierGroup.QuickModifierGroup.minSelect == 0 && modifierGroup.QuickModifierGroup.maxSelect == 0" > pick any or none </p>
            <p :class=" 'limit-alert ' + ( modifierGroup.isValid ? 'alert-blue' : 'alert-red' )" v-else-if=" modifierGroup.QuickModifierGroup.minSelect == 0 && modifierGroup.QuickModifierGroup.maxSelect > 0" > pick up to {{ modifierGroup.QuickModifierGroup.maxSelect }} </p>
            <p :class=" 'limit-alert ' + ( modifierGroup.isValid ? 'alert-blue' : 'alert-red' )" v-else-if=" modifierGroup.QuickModifierGroup.minSelect > 0 && modifierGroup.QuickModifierGroup.maxSelect == 0" > must pick at least {{ modifierGroup.QuickModifierGroup.minSelect }} </p>
            <p :class=" 'limit-alert ' + ( modifierGroup.isValid ? 'alert-blue' : 'alert-red' )" v-else-if=" modifierGroup.QuickModifierGroup.minSelect > 0 && modifierGroup.QuickModifierGroup.maxSelect > 0 && modifierGroup.QuickModifierGroup.maxSelect == modifierGroup.QuickModifierGroup.minSelect" > must pick exactly {{ modifierGroup.QuickModifierGroup.minSelect }}</p>
            <p :class=" 'limit-alert ' + ( modifierGroup.isValid ? 'alert-blue' : 'alert-red' )" v-else-if=" modifierGroup.QuickModifierGroup.minSelect > 0 && modifierGroup.QuickModifierGroup.maxSelect > 0" > must pick between {{ modifierGroup.QuickModifierGroup.minSelect }} & {{ modifierGroup.QuickModifierGroup.maxSelect }}</p>

            <ul class="modifier-group-list-wrapper">

                <li :class=" modGroupClasses( modifier ) " v-for=" ( modifier, modifierKey ) in modifierGroup.QuickModifier " :key=" modifierKey ">

                    <div class="input-style-outer-wrapper">

                        <div class="input-style-inner-wrapper">

                            <input
                                :disabled=" !isAvailable( modifier.available ) "
                                :id=" modifier.name "
                                @click=" addModifier( modifier, $event ) "
                                type="checkbox" :name=" modifier.quickModifierId "
                                :checked=" currentItemDetails.modifiers.includes( 'group_' + modifier.quickModifierGroupId + '_id_' + modifier.quickModifierId + '_name_' + modifier.name ) "
                            />
                            <label :for=" modifier.name "></label>
                        </div>
                        {{ modifier.name }}
                    </div>
                    <p :style="{ color: isAvailable( modifier.available ) ? 'black' : 'red' }">

                        {{ !isAvailable( modifier.available ) ? 'unavailable' : ( modifier.price ? '$' + parseFloat( modifier.price ).toFixed( 2 ) : '' ) }}
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'modifier-group',
        computed: {

            ...mapGetters({

                relevantModifierGroups : 'orderMenu/relevantModifierGroups',
                editingItem            : 'orderMenu/editingItem',
                currentItemDetails     : 'orderMenu/currentItemDetails'
            })
        },
        methods: {

            addModifier( modifier, event ){

                const data = {

                    checked : event.target.checked,
                    modId   : modifier.quickModifierGroupId,
                    mod     : modifier.quickModifierId,
                    name    : modifier.name
                }
                this.$store.dispatch( 'orderMenu/toggleModifier', data );
            },
            isAvailable( value ){

                // console.log( 'value: ', value );
                switch( value ){

                    case 0:
                    case "0":
                    case null:
                    case "null":

                        return false;
                        break;
                    case 1:
                    case "1":
                    case true:
                    case "true":

                        return true;
                        break;
                    default:

                        console.log( 'error invalid input to isAvailable()!' );
                        return false;
                        break;
                }
            },
            modGroupClasses( modifier ){

                const base = [ 'modifier-group-list-item' ];
                base.push( this.isAvailable( modifier.available ) ? 'is-available' : 'is-not-available' );
                return base.join( ' ' );
            }
        }
    }
</script>

<style scoped>

    .modifier-group-outer-wrapper {

        margin-top: 5px;
    }
    .modifier-group-title {

        padding: 0px 15px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9rem;
        transition: background-color 0.3s ease-in;
    }
    .background-valid {

        background-color: #ddd;
    }
    .background-invalid {

        background-color: rgba( 252, 159, 159, 0.5 );
    }
    .modifier-group-title > p {

        font-weight: bold;
        font-size: 1.2rem;
    }

    .limit-alert {

        margin: 0;
        text-align: right;
        margin-right: 10px;
    }
    .alert-red {

        color: red;
    }
    .alert-blue {

        color: blue;
    }

    .modifier-group-list-wrapper {

        margin: 10px 0px;
    }

    ul {

        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
    }

    .modifier-group-list-item {

        padding: 0px 20px;
        display: flex;
        position: relative;
        height: 45px;
        align-items: center;
        justify-content: space-between;
    }
    .is-available {

    }
    .is-not-available {

        background-color: rgba( 220, 180, 180, 0.5 );
    }

    .input-style-outer-wrapper {

        display: flex;
        align-items: center;
    }



    .input-style-inner-wrapper {

        position: relative;
        background: linear-gradient(90deg, #89a6ff, #0036f9);
        line-height: 0;
        perspective: 400px;
        margin-right: 5px;
    }
    .input-style-inner-wrapper input[type="checkbox"],
    .input-style-inner-wrapper label,
    .input-style-inner-wrapper label::before,
    .input-style-inner-wrapper label::after,
    .input-style-inner-wrapper {

        appearance: none;
        display: inline-block;
        border-radius: 1rem;
        border: 0;
        transition: .35s ease-in-out;
        box-sizing: border-box;
        cursor: pointer;
    }

    .input-style-inner-wrapper label {

        width: 3.9rem;
        height: 2.3rem;
        background: #d7d7d7;
        overflow: hidden;
    }
    .input-style-inner-wrapper input[type="checkbox"] {

        position: absolute;
        z-index: 1;
        width: 1.6rem;
        height: 1.6rem;
        top: 0.1rem;
        left: 0.1rem;
        background: linear-gradient(45deg, #dedede, #ffffff);
        box-shadow: 0 6px 7px rgba(0,0,0,0.3);
        outline: none;
    }

    .input-style-inner-wrapper input[type="checkbox"]:checked {

        left: 1.8rem;
    }

    .input-style-inner-wrapper input[type="checkbox"]:checked + label {

        background: transparent;
    }

    .input-style-inner-wrapper label::before{

        /*content: "· ·";*/
        position: absolute;
        overflow: hidden;
        left: .3rem;
        top: 1.0rem;
        height: 1rem;
        width: 1.35rem;
        letter-spacing: -.29rem;
        color: #9b9b9b;
        font-family: "Times New Roman", serif;
        z-index: 2;
        font-size: 1.7rem;
        border-radius: 0;
        transform-origin: 0 0 -.5rem;
        backface-visibility: hidden;
    }

    .input-style-inner-wrapper label::after {

        /*content: "●";*/
        position: absolute;
        overflow: hidden;
        top: 1.45rem;
        left: 0.7rem;
        height: 0.1rem;
        width: 1.35rem;
        letter-spacing: -.16rem;
        color: #9b9b9b;
        font-family: "Times New Roman", serif;
        z-index: 2;
        font-size: 0.4rem;
        border-radius: 0;
        transform-origin: 0 0 -.4rem;
        backface-visibility: hidden;
    }

    .input-style-inner-wrapper input[type="checkbox"]:checked + label::before {

        font-size: 2.0rem;
        left: 42px;
        top: 0.8rem;
        line-height: .1rem;
        transform: rotateY(360deg);
    }

    .input-style-inner-wrapper input[type="checkbox"]:checked + label::after {

        height: .46rem;
        top: 1.35rem;
        left: 2.6rem;
        font-size: 1.3rem;
        line-height: 0;
    }
</style>